module.exports = __webpack_public_path__ + "img/동대입구 카페.ad68274a.png";